import { IonButton, IonCol, IonGrid, IonIcon, IonModal, IonRow, IonText } from '@ionic/react';
import { logout } from '../../../actions/Login/action';
import { LogIn } from '../../../models/home/login.model';
import { useAuthService } from '../../../services/Auth';
import { store } from '../../../store';
import { clear, isEntitled } from '../../../utils/common';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { NO_ACCESS_MSG, REGISTER_TO_GET_FULL_ACCESS } from '../../../utils/constants';
import { ToastMessage } from '../../../utils/ToastMessage';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import './profileMenu.scss';
import { useTranslation } from 'react-i18next';
import { CustomModalWeb } from '../../pages/userProfile/CustomModalWeb';

const menuItems = [{ icon: 'assets/icon/Carrier_Profile.svg', title: 'Company Profile', redirectUrl: '/app/companyProfile' },
{ icon: 'assets/icon/Manage_Users.svg', title: 'Manage Users', redirectUrl: '/app/manage/ManageUser' },
{ icon: 'assets/icon/Preferences.svg', title: 'Preferences', redirectUrl: '/app/preferences' },
{ icon: 'assets/icon/Logout-Icon.svg', title: 'Log Out', redirectUrl: '', isLogout: true }]
export const ProfileMenu: React.FunctionComponent<any> = (props: any) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { userDetails } = props;
  const { push } = useHistory();
  const authService = useAuthService();
  const _clear = new LogIn();
  useEffect(() => {
    setShowMenu(props.showMenu);
    if (props.showMenu) {
      setScreenName('screen_manage');
      // Analytics implementation
      logEvent(EVENT.SV_MANAGE_PROFILE, {
        screen: SCREEN.MANAGE_PROFILE,
        carrierId: userDetails && userDetails.carrierId
      });
    }
  }, [props.showMenu])

  const onMenuSelect = (menu: any) => {
    props.closeModal(false);
    if (menu.isLogout) {
      setShowLogoutModal(true);
    } else if (menu.redirectUrl) {
      if (menu.redirectUrl === '/app/manage/ManageUser') {
        if (!isEntitled('manage', 'manageUsersWeb')) {
          ToastMessage.show(NO_ACCESS_MSG);
          return;
        }
      }else if((menu.redirectUrl === '/app/companyProfile' || menu.redirectUrl === '/app/preferences') && !isEntitled('manage', 'carrierProfile')){
        ToastMessage.show(REGISTER_TO_GET_FULL_ACCESS);
        return;
      }

      push(menu.redirectUrl);
    }
  }

  async function azureLogout() {
    setShowLogoutModal(false);
    await clear();
    await authService.logout();
    _clear.clearToken();
    window.localStorage.clear();
    store.dispatch(logout())
  }
  const { t } = useTranslation();
  const logoutModalProps = {
    title: t('Logout'),
    message_content: props.isRegistrationPage
      ? t('REGISTRATION_ALERT_MESSAGE')
      : t('ALERT_MESSAGE'),
    size: 'small extra_small_height',
    buttons: [
      {
        title: t('Logout'),
        type: 'secondary-cta-btn-web',
        onClick: async () => azureLogout()
      },
      {
        title: t('Cancel'),
        type: 'primary-cta-btn-web',
        onClick: () => setShowLogoutModal(false)
      }
    ]
  };
  return (
    <>
      <IonModal
        isOpen={showMenu}
        cssClass={isEntitled('manage', 'manageUsersWeb') ? 'profileMenu-modal' : 'profileMenu-modal test-mg'}
        backdropDismiss={true}
        showBackdrop={false}
        onDidDismiss={() => props.closeModal(false)}
      >
        <IonGrid class='profileMenu-grid'>
          <IonGrid class='profile-grid'>
            <IonRow>
              <IonCol class='user-icon-col'>
                <IonIcon class='user-icon' src='assets/icon/man.svg'></IonIcon>
              </IonCol>
              <IonCol class='userName-col'>
                <IonRow>
                  <IonText class='userName'>{userDetails && userDetails.firstName} {userDetails && userDetails.lastName} </IonText>
                </IonRow>
                <IonRow>
                  <IonText class='userUpn'>{userDetails && userDetails.userPrincipalName}</IonText>
                </IonRow>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonButton class='profile-btn' onClick={() => {
                setShowMenu(false);
                push('/app/userProfile', {
                  title: 'My Profile'
                });
              }}>
                My Profile
              </IonButton>
            </IonRow>
          </IonGrid>

          <IonGrid class='menu-grid'>
            {menuItems.map((section: any, index: any) => {
              if(section.title === 'Manage Users' && !isEntitled('manage', 'manageUsersWeb')) {
                return null;
              }
              return (
                <IonRow class='menu-row' key={index} onClick={() => onMenuSelect(section)}>
                  <IonCol size='2' class='menu-icon-col'> <IonIcon src={section.icon}></IonIcon></IonCol>
                  <IonCol size='10' class='menu-title-col'> <IonText>{section.title}</IonText></IonCol>
                </IonRow>
              )
            })
            }
          </IonGrid>

        </IonGrid>
      </IonModal>
      <CustomModalWeb isModalOpen={showLogoutModal} {...logoutModalProps} />
    </>
  )
}
